export default __webpack_public_path__ + "static/media/help_banner.917e86ff.png";